import "@accessible360/accessible-slick/slick/slick.min";
const $ = jQuery;

$(".slide-carousel .slider").slick({
  arrows: false,
  autoplay: false,
  autoplaySpeed: 6000,
  dots: false,
  infinite: true,
  mobileFirst: true,
  regionLabel: "hero-carousel",
  rows: 0,
  speed: 500,
});

$(".slider-nav a[data-slide]").on("click", function (e) {
  e.preventDefault();
  var slideNum = $(this).data("slide");
  $(".slide-carousel .slider").slick("slickGoTo", slideNum - 1);
});

$(".slide-carousel .slider").on(
  "beforeChange",
  function (event, slick, currentSlide, nextSlide) {
    console.log(nextSlide);

    $(".slider-nav a").each(function () {
      $(this).removeClass("active");
      if ($(this).data("slide") == nextSlide + 1) {
        $(this).addClass("active");
      }
    });
  }
);

$(".squares.use-as-slider").slick({
  arrows: true,
  autoplay: false,
  autoplaySpeed: 6000,
  dots: false,
  infinite: true,
  mobileFirst: true,
  nextArrow: '<button type="button" class="slick-next"></button>',
  prevArrow: '<button type="button" class="slick-prev"></button>',
  rows: 0,
  // slidesToShow: 4,
  speed: 500,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
});

$(".testimonial-slider__slider").slick({
  arrows: false,
  autoplay: true,
  autoplaySpeed: 10000,
  dots: true,
  fade: true,
  mobileFirst: true,
  regionLabel: "testimonial-carousel",
});

$('.image-content-columns.has-slideshow .image-content-columns__image').slick({
  autoplay: true,
  autoplaySpeed: 5000,
  useAutoplayToggleButton: false,
  dots: false,
  infinite: true,
  arrows: false,
  speed: 1000,
  fade: true,
  cssEase: 'linear',
});



// WEBPACK FOOTER //
// ./scripts/slickSliders.js